import { useMemo } from "react";
import {
    MainInterface,
    type MainInterfaceProps,
} from "@components/mainInterface/MainInterface";
import { useOpenTaskUrl } from "./useOpenTaskUrl";

/** An Actions page's frame: while a task is open, the "Actions" breadcrumb closes it. */
export const TasksMainInterface = (
    props: Omit<MainInterfaceProps, "breadcrumbs" | "fullPage">,
) => {
    const { selectedTaskId, closeTask } = useOpenTaskUrl();
    const breadcrumbs = useMemo(
        () => [
            {
                label: "Actions",
                onClick: selectedTaskId === null ? undefined : closeTask,
            },
        ],
        [closeTask, selectedTaskId],
    );

    return <MainInterface {...props} breadcrumbs={breadcrumbs} fullPage />;
};
